import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
var propTypes = {
  /**
  * Specifies whether the tile is vertically or horizontally oriented
  * Available options: "vertical", "horizontal"
  */
  layout: PropTypes.oneOf(['vertical', 'horizontal'])
};
var SecondaryTile = createComponent({
  displayName: 'SecondaryTile',
  root: 'div',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.secondaryTile,
  propConfig: {
    classNames: function classNames(props) {
      var classesSet = new Set(['swan-secondary-tile']);
      if (props.layout === 'horizontal') classesSet.add('swan-secondary-tile-horizontal');
      return classesSet;
    }
  }
});
SecondaryTile.defaultProps = {
  layout: 'vertical'
};
export { SecondaryTile };